import React, { useState } from 'react';
import api from '../../services/api.js';
import Modal from '../../components/Modal/Modal.jsx';

import { Grid } from "@mui/material";
import { BannerGrid, CotacaoGrid, FormInput, FormButton, ButtonWrapper } from "./Cotacao.js";

import { Footer } from '../../components/Footer/Footer.jsx';
import { Header } from '../../components/Header/Header.jsx';

import Circle from '../../assets/cangoo-banner-elemento.png'



export function Cotacao() {
  const [sending, setSending] = useState(false);
  const [modalOpen, setModalOpen] = useState(false); 

  const [nome, setNome] = useState('');
  const [empresa, setEmpresa] = useState('');
  const [cnpj, setCnpj] = useState('');
  const [email, setEmail] = useState('');
  const [cidade_origem, setCidade_origem] = useState('');
  const [uf_origem, setUf_origem] = useState('');
  const [cidade_destino, setCidade_destino] = useState('');
  const [uf_destino, setUf_destino] = useState('');
  const [tipo_produto, setTipo_produto] = useState('');
  const [volumes, setVolumes] = useState('');
  const [medidas, setMedidas] = useState('');
  const [peso, setPeso] = useState('');
  const [valor, setValor] = useState('');


  const Clean = () => {
    setNome('');
    setEmpresa('');
    setCnpj('');
    setEmail('');
    setCidade_origem('');
    setUf_origem('');
    setCidade_destino('');
    setUf_destino('');
    setTipo_produto('');
    setVolumes('');
    setMedidas('');
    setPeso('');
    setValor('');
  };


  const Submit = (event) => {
    event.preventDefault();
    setSending(true);
    
    const data = {
      pagina: "Cotação de Frete", 
      nome, 
      empresa,
      cnpj,
      email,
      cidade_origem,
      uf_origem,
      cidade_destino,
      uf_destino,
      tipo_produto,
      volumes,
      medidas,
      peso,
      valor
  };

    api.post(`/notifications/cangoo/`, data).then(res => { 
      setSending(false); 
      setModalOpen(true);
      Clean();
      
    }).catch((error) => {
      setSending(false);
      console.log(error);
    });
  };

    return (
      <>
      <Header/>

      <BannerGrid container>
        <Grid item xs={12} sm={12} md={12}>
<div className="title">
  <h1>Cotação de Frete</h1>
  <img src={Circle} alt="" />
</div>
        </Grid>

      </BannerGrid>


      <CotacaoGrid container>
      <Grid className="texto" item xs={12} sm={12} md={12}>
<h1>Estamos prontos para<br/>
<span>cuidar</span> da sua carga</h1>

<p>Preencha o formulário, retornaremos com a melhor solução logística.</p>
        </Grid>


<Grid className='form-cotacao' item xs={12} sm={12} md={12}>
<form id='form' onSubmit={Submit}>
  
  <div className='input'>
  <label htmlFor="nome">Nome</label>
  <FormInput
            id='nome'
            name='nome'
            type='text'
            value={nome}
            onChange={(e) => setNome(e.target.value)}
            required />
  </div>

  <div className='input empresa-text'>
  <label htmlFor="empresa">Empresa</label>
  <FormInput
            id='empresa'
            name='empresa'
            type='text'
            value={empresa}
            onChange={(e) => setEmpresa(e.target.value)}
            required />
            <small>Atenção! Não atendemos Pessoa Física. Somente CNPJ.</small>
  </div>

  <div className='input'>
  <label htmlFor="cnpj">CNPJ</label>
  <FormInput
            id='cnpj'
            name='cnpj'
            type='text'
            value={cnpj}
            onChange={(e) => setCnpj(e.target.value)}
            required />
  </div>

  <div className='input'>
  <label htmlFor="email">E-mail</label>
  <FormInput
            id='email'
            name='email'
            type='text'
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required />
  </div>



<div className="double-input line-top">
<div className='input cidade'>
  <label htmlFor="cidade_origem">Cidade Origem</label>
  <FormInput
            id='cidade_origem'
            name='cidade_origem'
            type='text'
            value={cidade_origem}
            onChange={(e) => setCidade_origem(e.target.value)}
            required />
  </div>

  <div className='input uf'>
  <label htmlFor="uf_origem">UF</label>
  <FormInput
            id='uf_origem'
            name='uf_origem'
            type='text'
            value={uf_origem}
            onChange={(e) => setUf_origem(e.target.value)}
            required />
  </div>
</div>

<div className="double-input">
<div className='input cidade'>
  <label htmlFor="cidade_destino">Cidade Destino</label>
  <FormInput
            id='cidade_destino'
            name='cidade_destino'
            type='text'
            value={cidade_destino}
            onChange={(e) => setCidade_destino(e.target.value)}
            required />
  </div>

  <div className='input uf'>
  <label htmlFor="uf_destino">UF</label>
  <FormInput
            id='uf_destino'
            name='uf_destino'
            type='text'
            value={uf_destino}
            onChange={(e) => setUf_destino(e.target.value)}
            required />
  </div>
</div>

<div className='input'>
  <label htmlFor="tipo_produto">Tipo de Produto</label>
  <FormInput
            id='tipo_produto'
            name='tipo_produto'
            type='text'
            value={tipo_produto}
            onChange={(e) => setTipo_produto(e.target.value)}
            required />
  </div>



  <div className='input line-top'>
  <label htmlFor="volumes">Qtd Volumes</label>
  <FormInput
            id='volumes'
            name='volumes'
            type='text'
            value={volumes}
            onChange={(e) => setVolumes(e.target.value)}
            required />
  </div>

  <div className='input medidas-text'>
  <label htmlFor="medidas">Medidas (cm)</label>
  <FormInput
            id='medidas'
            name='medidas'
            type='text'
            value={medidas}
            onChange={(e) => setMedidas(e.target.value)}
            required />
            <small>Altura x Largura x Comprimento</small>
  </div>

  <div className='input'>
  <label htmlFor="peso">Peso</label>
  <FormInput
            id='peso'
            name='peso'
            type='text'
            value={peso}
            onChange={(e) => setPeso(e.target.value)}
            required />
  </div>

  <div className='input'>
  <label htmlFor="valor">Valor (R$)</label>
  <FormInput
            id='valor'
            name='valor'
            type='text'
            value={valor}
            onChange={(e) => setValor(e.target.value)}
            required />
  </div>



       <ButtonWrapper>
          <FormButton type="submit" form='form' disabled={sending}>
            {sending ? 'enviando...' : 'enviar'}
          </FormButton>
        </ButtonWrapper>

</form>

</Grid>

      </CotacaoGrid>
      <Footer/>

<Modal open={modalOpen} onClose={() => setModalOpen(false)} />
      </>
    )
  }